<template>
  <div>
        <!-- Banner -->
        <section id="banner">
          <div class="content">
            <header>
              <h1>
                Hi, I’m Heltec Taiwan
                <br />
              </h1>
              <p>物聯網應用開發的好幫手</p>
            </header>
            <p>Heltec於2013年成立，專注於物聯網產品研發與生產。Heltec 致力於服務客戶物聯網產品整合開發。
                 這裡是 Heltec Taiwan 團隊直營商店,讓我們協助實現您的想法吧!</p>
                <el-button  type="primary" plain>
                  <a href="https://heltec.cashier.ecpay.com.tw">
                  取得元件
                  </a>
                  </el-button>
          </div>
          <span class="image object">
            <img src="../../static/images/home1.jpg" alt />
          </span>
        </section>

        <!-- Section -->
        <section>
          <header class="major">
            <a name="features"></a>
            <h2>產品特色</h2>
          </header>
          <div class="features">
            <article>
              <span class="icon">
                <font-awesome-icon icon="code"  class="fontawesomeicon"/>
              </span>
              <div class="content">
                <h3>Arduino 相容</h3>
                <p>軟體模組化設計完善，用C++將硬體抽象成函式庫。軟體文件齊全，寫法規範，官方的函式庫更是不可多得的範例級程式，簡潔高效。</p>
              </div>
            </article>
            <article>
              <span class="icon">
                <font-awesome-icon  :icon="['fab', 'superpowers']" class="fontawesomeicon" />
              </span>
              <div class="content">
                <h3>整合供電迴路</h3>
                <p>整合電源管理與電池充放電迴路，高效率低功耗長壽命。</p>
              </div>
            </article>
            <article>
              <span class="icon">
                <font-awesome-icon  :icon="['fab', 'hubspot']" class="fontawesomeicon" />
              </span>
              <div class="content">
                <h3>支援多種通訊方式</h3>
                <p>我們提供多種通訊方式LoRa 點對點, LoRaWAN 點對點,WIFI Node，您一定可以選到適合的連接方式。</p>
              </div>
            </article>
            <article>
              <span class="icon">
                 <font-awesome-icon icon="globe"  class="fontawesomeicon"/>
              </span>
              <div class="content">
                <h3>全球開發者論壇</h3>
                <p>隨時與全球開發者共同討論與學習創造</p>
              </div>
            </article>
          </div>
        </section>
        <!-- Section 1-->
        <section>
          <header class="major">
            <h2>Heltec CubeCell 系列</h2>
          </header>
          <span class="image main">
            <img src="../../static/images/cubecell.jpg" alt />
          </span>

          <el-row :gutter="20">
            <el-col
              :xs="24"
              :sm="12"
              :md="8"
              :lg="8"
              :xl="6"
              v-for="(item) in cubecellProductList"
              :key="item.index"
            >
              <product :productID="item" category="cubecell"></product>
            </el-col>
          </el-row>
        </section>
        <!-- Section 1-->
        <!-- Section 2-->
        <section>
          <header class="major">
            <h2>Heltec Wifi 產品系列</h2>
          </header>
          <span class="image main">
            <img src="../../static/images/loranode.jpg" alt />
          </span>
          <el-row :gutter="20">
            <el-col
              :xs="24"
              :sm="12"
              :md="8"
              :lg="8"
              :xl="6"
              v-for="(item) in loranodeProductList"
              :key="item.index"
            >
              <product :productID="item" category="loranode"></product>
            </el-col>
          </el-row>
        </section>
        <!-- Section 2-->
        <!-- Section 3-->
        <section>
          <header class="major">
            <h2>Heltec LoRaWAN Gateway 系列</h2>
          </header>
          <span class="image main">
            <img src="../../static/images/lorawangateway.jpg" alt />
          </span>
          <el-row :gutter="20">
            <el-col
              :xs="24"
              :sm="12"
              :md="8"
              :lg="8"
              :xl="6"
              v-for="(item) in lorawangatewayList"
              :key="item.index"
            >
              <product :productID="item" category="lorawangateway"></product>
            </el-col>
          </el-row>
        </section>
        <!-- Section 3-->
        <!-- Section 4-->
        <section>
          <header class="major">
            <h2>Heltec 配件</h2>
          </header>
          <span class="image main">
            <img src="../../static/images/accessories.jpg" alt />
          </span>
          <el-row :gutter="20">
            <el-col
              :xs="24"
              :sm="12"
              :md="8"
              :lg="8"
              :xl="6"
              v-for="(item) in accessoriesList"
              :key="item.index"
            >
              <product :productID="item" category="accessories"></product>
            </el-col>
          </el-row>
        </section>
        <!-- Section 4-->
        <!-- Section 5-->
        <!-- <section>
          <header class="major">
            <h2>合作通路</h2>
          </header>
          <el-row :gutter="20">
            <el-col
              :xs="12"
              :sm="12"
              :md="8"
              :lg="6"
              :xl="6"
              v-for="(item) in venderList"
              :key="item.index"
            >
              <product :vendor="item" category="vendor"></product>
            </el-col>
          </el-row>
        </section> -->
  </div>
</template>

<style lang="scss">
.logo {
  border-bottom: dotted 0px;
}
.aside {
  margin-left: 10px;
  width: 200px;
}
/* .cards {
  margin-right: 50px;
} */
.fontawesomeicon {
  font-size: 45px;
  margin-top: 52px;
  color: #00A2E9;
}
.strong {
  color: #00A2E9;
}
</style>

<script>

import axios from 'axios';
import product from './product.vue';

export default {
  components: {
    product,
  },
  data() {
    return {
      category: '',
      cubecellProductList: ['HTCC-AM01', 'HTCC-AM02', 'HTCC-AB01', 'HTCC-AB02', 'HTCC-AB02A', 'HTCC-AC01', 'HTCC-AC02', 'HTCC-CPC01'],
      loranodeProductList: ['HTIT-WST', 'HTIT-WSL', 'HTIT-WS', 'HTIT-WB32', 'HTIT-WB32C'],
      lorawangatewayList: ['HT-M00', 'HT-M01', 'HT-M02'],
      accessoriesList: ['BATTERY-80', 'BATTERY-1000', 'EZ-ANT', 'HTCC-BH1750', 'HTCC-BMP180', 'HTCC-CCS811B', 'HTCC-HDC1080', 'HTCC-MPU9250'],
      venderList: ['shopee', 'yahoo', 'pchome', 'ruten'],
    };
  },
  computed: {},
  mounted() {

  },
  methods: {
    getData() {
      axios.get('/Users/heltec/Documents/網站/heltec/static/data.json').then((response) => {
        // eslint-disable-next-line
        console.log(response.data);
      }, () => {
        // eslint-disable-next-line
        console.log('error');
      });
    },
  },
  created() {
    // Fetch Dat
    this.getData();
  },
};
</script>
